import React, { Fragment, useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ContactInformation.module.scss'
import { emailAddressAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const EmailAddress = ({ t, emailAddressValid, validateEmailAddress, emailAddressError, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const emailAddress = useSelector((state) => state.app.emailAddress)

  const handleEmail = (e) => {
    try {
      let email = e.currentTarget.value.replace(/\s/g, '')
      dispatch(emailAddressAction(email))
      // validateEmailAddress(email)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleOnBlur = () => {
    SetIsFocussed(false)
    // validateEmailAddress(emailAddress)
  }

  const emailAndHelp = (
    <Fragment>
      <label className="control-label" htmlFor="EmailAddress">
        {t('contact_info.email_address')}
      </label>
      <div className="help-field">{t('contact_info.your_receipt_will_be')}</div>
    </Fragment>
  )

  return (
    <div className={styles['fields_margin']}>
      <div className="form-group">
        {emailAddressValid === false ? (
          <div className={styles['error_email_div']}>
            <div className={styles['vertical_line']}></div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {emailAndHelp}
              <div style={{ display: 'flex', flexDirection: 'row', gap: '5px' }} className="has-error">
                <i className="fa fa-exclamation-circle" aria-hidden="true" style={{ marginTop: '5px' }}></i>
                <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(emailAddressError)}</div>
              </div>
              <input
                type="text"
                id="EmailAddress"
                style={{ border: '1px solid #d3423b' }}
                className={['ns-input form-control', 'has-error', styles['input_style']].join(' ')}
                onBlur={handleOnBlur}
                value={emailAddress}
                onChange={handleEmail}
                onFocus={() => SetIsFocussed(true)}
                autoComplete="off"
                maxLength="50"
              />
            </div>
          </div>
        ) : (
          <Fragment>
            {emailAndHelp}
            <input
              autoFocus
              type="email"
              id="EmailAddress"
              className={['ns-input form-control', styles['input_style']].join(' ')}
              onBlur={handleOnBlur}
              value={emailAddress}
              onChange={handleEmail}
              onFocus={() => SetIsFocussed(true)}
              autoComplete="off"
              maxLength="50"
            />
          </Fragment>
        )}
      </div>
    </div>
  )
}

export default withTranslation('common')(EmailAddress)
